var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXrp = function SvgXrp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#393939",
    d: "M15.916 7.958A7.958 7.958 0 1 1 0 7.958a7.958 7.958 0 0 1 15.916 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.17 4.656H4.015l2.407 2.382a2.25 2.25 0 0 0 3.156 0l2.407-2.382h-1.157L9 6.465a1.424 1.424 0 0 1-1.999 0zM10.843 11.279H12L9.578 8.882a2.25 2.25 0 0 0-3.156 0L4 11.28h1.156L7 9.455a1.424 1.424 0 0 1 1.999 0z"
  })));
};
export default SvgXrp;